<template>
    <div class="popularType-main ">
        <div class="popularType_content flex newUi">
            <div class="content_center flexColumn" style="padding: 10px;justify-content: space-between;">
                <div class="content_style" style="height: 100%;">
                    <div class="newUiHeaderDP">
                        施工质量问题
                    </div>
                    <div class="style_content">
                        <div style="height: 100%; width: 100%; justify-content: space-between;" class="flex">
                            <div style="height: 100%; width: 25%;">
                                <div class="content_style" style="height: 100%;">
                                    <div class="style_content" style="height: 100%;">
                                        <el-aside width="100%" class="elAside" style="height: 90%;overflow:hidden">
                                            <zTreeZN :zNodes="zNodes" @getData="getDataList"
                                                @addFileZtree="addFileZtree" :options="{
                                                    id: 'id',
                                                    pid: 'parentid',
                                                    label: 'tname',
                                                    zTreeId: 'PdeptTree',
                                                    delType: {
                                                        add: false,
                                                        update: false,
                                                        del: false,
                                                        addFile: upOrdelUserAuthority,
                                                    },
                                                }" ref="zTree" />
                                        </el-aside>
                                    </div>
                                </div>
                            </div>
                            <div style="height: 100%; width: 74%;">
                                <div class="content_style" style="height: 100%;">
                                    <el-row class="FCC" style="justify-content: flex-start;margin-bottom:10px">
                                        <el-col :span="4">
                                            <el-select v-model="questionValue" placeholder="请选择"
                                                @change="questionValueChange">
                                                <el-option v-for="item in questionOptions" :key="item.value"
                                                    :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                        <el-col :span="4" style="margin-left:20px">
                                            <el-input placeholder="请输入标题搜索" class="search-input " v-model="searchword"
                                                @change="getKeyworld"></el-input>
                                        </el-col>
                                    </el-row>
                                    <el-table :data="dataList" highlight-current-row height="90%" :header-cell-style="{
                                        background: '#71A5D0',
                                        color: '#fff',
                                        textAlign: 'center',
                                    }" :cell-style="{ textAlign: 'center' }">
                                        <el-table-column type="index" label="序号" width="55">
                                        </el-table-column>
                                        <el-table-column align="center" prop="title" label="标题">
                                            <template slot-scope="scope">
                                                <el-button size="small" type="text" class="wirte"
                                                    @click="lookQuestion(scope.row)">{{
                                                        scope.row.title }}</el-button>
                                            </template>
                                        </el-table-column>
                                        <el-table-column align="center" prop="prde03" label="指定处理人">
                                            <template slot-scope="scope">
                                                <el-button size="small" type="text" class="wirte">
                                                    {{scope.row.replayusers != null ?
                                                        (scope.row.replayusers.map((el) => el.user04)).join() : '请设置处理人员'
                                                    }}</el-button>
                                            </template>
                                        </el-table-column>
                                        <el-table-column align="center" prop="strstatus" label="状态">
                                            <template slot-scope="scope">
                                                <el-button size="small" type="text" class="wirte">{{
                                                    scope.row.strstatus
                                                }}</el-button>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="status" label="操作">
                                            <template slot-scope="scope">
                                                <el-button size="small" type="primary" plain
                                                    @click="lookQuestion(scope.row)">详情</el-button>
                                                <el-button v-if="upOrdelUserAuthority || scope.row.creatuser == uid"
                                                    size="small" type="warning" plain
                                                    @click="delChange(scope.row.id)">删除</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content_left flexColumn">
                <div class="content_style" style="height: 100%;">
                    <div class="newUiHeaderDP">
                        问题解决情况
                    </div>
                    <div class="style_content" style="">
                        <div style="width: 100%;height: 98%;overflow: auto;">
                            <el-row style=" margin:15px 5px" v-for="(item, index) in dataList1" :key="index">
                                <el-carousel height="200px" v-if="item.disposelsit[
                                    item.disposelsit.length - 1
                                ].disposefiles.split(',').length > 1
                                ">
                                    <el-carousel-item v-for="file, index in item.disposelsit[
                                        item.disposelsit.length - 1
                                    ].disposefiles.split(',')" :key="index">
                                        <el-image style="width: 100%; height: 100%" :src="actionUrl + file"
                                            fit="fill"></el-image>
                                    </el-carousel-item>
                                </el-carousel>
                                <el-image v-else style="width: 100%; height: 200px" :src="actionUrl +
                                    item.disposelsit[item.disposelsit.length - 1].disposefiles
                                    " fit="fill"></el-image>
                                <div
                                    style="text-align: center;line-height: 30px;background-color: #376D97;margin-top: -4px;">
                                    {{ item.title }}
                                </div>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 新增文件 -->
        <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="新增施工质量问题"
            :visible.sync="ADDFileShow" width="50%" height="50%" :before-close="handleClose" class="inputStyle">
            <el-form :model="addfbForm" :rules="fbRule" ref="fbForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="问题标题：" prop="title">
                    <el-input v-model="addfbForm.title"></el-input>
                </el-form-item>
                <el-form-item label="问题描述：" prop="strcount">
                    <el-input type="textarea" v-model="addfbForm.strcount" :autosize="{ minRows: 2, maxRows: 10 }"
                        maxlength="500" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="图片" prop="fileList" ref="imageFile">
                    <el-upload ref="upload" v-model="addfbForm.fileList" multiple class="upload-demo"
                        accept=".jpg,.jpeg,.png,.JPG,.JPEG" :action="actionUrl" :on-change="handleChange"
                        :before-upload="beforeUpload">
                        <el-button size="medium" style="color: #333;">点击选择文件</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div class="txt-cen-pa20-0">
                <el-button @click="submitUpdata('fbForm')" type="primary">确定</el-button>
            </div>
        </el-dialog>
        <!-- 反馈 -->
        <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="新增" :visible.sync="feedbackShow"
            width="50%" height="50%" :before-close="handleClose" class="inputStyle">
            <el-form :model="feedbackForm" :rules="feedbackRule" ref="Updatefeedback" label-width="230px"
                class="demo-ruleForm mar-r80 ">
                <el-form-item label="关联文件：" prop="fileName">
                    <el-input disabled v-model="feedbackForm.fileName" placeholder="必填，文本，手动输入"></el-input>
                </el-form-item>
                <el-form-item label="问题反馈清单标题：" prop="title">
                    <el-input type="text" maxlength="30" v-model="feedbackForm.title"
                        placeholder="请输入标题，限制30个汉字"></el-input>
                </el-form-item>
                <el-form-item label="问题反馈清单内容：" prop="strcount">
                    <ckediter4 ref="ck" v-model="feedbackForm.strcount" :disable="false"></ckediter4>
                </el-form-item>
            </el-form>
            <el-row>
                <el-col :span="2" :offset="22">
                    <el-button type="primary" @click="submitfeedback('Updatefeedback')">确定</el-button>
                </el-col>
            </el-row>
        </el-dialog>
        <!-- 反馈问题回复预览 -->
        <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" title="施工质量问题单"
            :visible.sync="ShowQuestion" width="70%" top="1%" class="inputStyle">
            <el-form :model="SGForm" :rules="SGRule" label-width="160px" ref="addSGForm"
                style="padding-right: 60px;height:650px;overflow-y: auto;">
                <el-form-item label="问题标题：" prop="title">
                    <div>{{ SGForm.title }}</div>
                </el-form-item>
                <el-row style="padding:0px">
                    <el-col :span="6">
                        <el-form-item label="问题状态：" prop="strstatus">
                            <div>{{ SGForm.strstatus }}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <!-- <el-form-item label="关闭时间：" prop="">
                            <div>{{ SGForm.colsetime == "0001/01/01 00:00:00" ? "" : SGForm.colsetime }}</div>
                        </el-form-item> -->
                    </el-col>
                </el-row>
                <el-row style="padding:0px;margin-top: 20px;" v-for="(item, index) in SGForm.disposelsit" :key="index">
                    <el-row style="padding:0px">
                        <el-col :span="6">
                            <el-form-item :label="index == 0 ? '发起人：' : '追问人：'" prop="">
                                <div>{{ item.fbusername }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <!-- <el-form-item :label="index == 0 ? '发起时间：' : '追问时间：'" prop="">
                                <div>{{ item.fbdate }}</div>
                            </el-form-item> -->
                        </el-col>
                        <template
                            v-if="(!(index + 1 == SGForm.disposelsit.length && replyUserAuthority == false) || item.disposecontent != null) || (SGForm.creatuser == uid && replyUserAuthority)">
                            <el-col :span="6">
                                <el-form-item label="处理人：" prop="">
                                    <div>{{ item.disusername }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- <el-form-item label="处理时间：" prop="">
                                    <div>{{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}
                                    </div>
                                </el-form-item> -->
                            </el-col>
                        </template>
                    </el-row>
                    <el-col :span="12">
                        <el-form-item label="问题描述：" prop="fbcontent">
                            <div style="width: 100%;max-height: 110px;overflow-y: auto;">
                                <p>{{ item.fbcontent }}</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="图片：" prop="fbfiles">
                            <el-carousel height="200px" style="margin-top: 10px;">
                                <el-carousel-item v-for="(file) in (item.fbfiles.split(','))" :key="file">
                                    <el-image style="width: 100%; height: 100%;border-radius: 4px;"
                                        :src="actionUrl + file" fit="fill"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                        </el-form-item>
                    </el-col>
                    <template v-if="SGForm.creatuser == uid && replyUserAuthority">
                        <el-col :span="12">
                            <el-form-item label="处理情况：" prop="disposecontent">
                                <el-input v-if="!questionDisable && index + 1 == SGForm.disposelsit.length"
                                    type="textarea" v-model="item.disposecontent"
                                    :autosize="{ minRows: 5, maxRows: 10 }" maxlength="500" show-word-limit></el-input>
                                <div v-else style="width: 100%;max-height: 110px;overflow-y: auto;">
                                    <p>{{ item.disposecontent }}</p>
                                </div>
                            </el-form-item>
                            <el-form-item label="图片：" prop="fileList" ref="imageFile">
                                <el-upload v-if="item.disposefiles == null" ref="upload" v-model="fileList" multiple
                                    class="upload-demo" accept=".jpg,.jpeg,.png,.JPG,.JPEG" :action="actionUrl"
                                    :on-change="handleChange1" :before-upload="beforeUpload">
                                    <el-button size="medium">点击选择文件</el-button>
                                </el-upload>
                                <el-carousel v-else height="200px" style="margin-top: 10px;">
                                    <el-carousel-item
                                        v-for="(file1) in (item.disposefiles != null ? item.disposefiles.split(',') : [])"
                                        :key="file1">
                                        <el-image style="width: 100%; height: 100%;border-radius: 4px;"
                                            :src="actionUrl + file1" fit="fill"></el-image>
                                    </el-carousel-item>
                                </el-carousel>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2" :offset="22"
                            v-if="submitStatus == false && index + 1 == SGForm.disposelsit.length">
                            <el-button type="primary" style="width:100%"
                                @click="questionBtn(item, false, index)">确定</el-button>
                        </el-col>
                        <el-col :span="4" :offset="20"
                            v-if="replayStatus == true && index + 1 == SGForm.disposelsit.length">
                            <div style="float: right;">
                                <el-button @click="continueBtn()">不合格</el-button>
                                <el-button type="primary" v-show="zwStatus == true"
                                    @click="questionBtn(item, true, index)">确认关闭</el-button>
                            </div>
                        </el-col>
                    </template>
                    <template v-else>
                        <template
                            v-if="!(index + 1 == SGForm.disposelsit.length && replyUserAuthority == false) || item.disposecontent != null">
                            <el-col :span="12">
                                <el-form-item label="处理情况：" prop="disposecontent">
                                    <el-input
                                        v-if="(item.disposecontent == null ? true : !questionDisable) && index + 1 == SGForm.disposelsit.length"
                                        type="textarea" v-model="item.disposecontent"
                                        :autosize="{ minRows: 5, maxRows: 10 }" maxlength="500"
                                        show-word-limit></el-input>
                                    <div v-else style="width: 100%;max-height: 110px;overflow-y: auto;">
                                        <p>{{ item.disposecontent }}</p>
                                    </div>
                                </el-form-item>
                                <el-form-item label="图片：" prop="fileList" ref="imageFile">
                                    <el-upload v-if="item.disposefiles == null" ref="upload" v-model="fileList" multiple
                                        class="upload-demo" accept=".jpg,.jpeg,.png,.JPG,.JPEG" :action="actionUrl"
                                        :on-change="handleChange1" :before-upload="beforeUpload">
                                        <el-button size="medium">点击选择文件</el-button>
                                    </el-upload>
                                    <el-carousel v-else height="200px" style="margin-top: 10px;">
                                        <el-carousel-item
                                            v-for="(file1) in (item.disposefiles != null ? item.disposefiles.split(',') : [])"
                                            :key="file1">
                                            <el-image style="width: 100%; height: 100%;border-radius: 4px;"
                                                :src="actionUrl + file1" fit="fill"></el-image>
                                        </el-carousel-item>
                                    </el-carousel>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" :offset="22"
                                v-if="item.disusername == null && index + 1 == SGForm.disposelsit.length">
                                <el-button type="primary" style="width:100%"
                                    @click="questionBtn(item, false, index)">确定</el-button>
                            </el-col>
                            <el-col :span="4" :offset="20"
                                v-if="SGForm.creatuser == uid && index + 1 == SGForm.disposelsit.length && replayStatus == true">
                                <div style="float: right;">
                                    <el-button @click="continueBtn()">不合格</el-button>
                                    <el-button type="primary" v-show="zwStatus == true"
                                        @click="questionBtn(item, true, index)">确认关闭</el-button>
                                </div>
                            </el-col>
                        </template>
                    </template>
                </el-row>
                <el-row>
                    <el-col :span="12" v-if="zwStatus == false">
                        <el-form-item label="问题描述：" prop="">
                            <el-input type="textarea" v-model="newFeedback.fbcontent"
                                :autosize="{ minRows: 4, maxRows: 10 }" maxlength="500" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="图片：" prop="" ref="imageFile">
                            <el-upload ref="upload" v-model="fileList" multiple class="upload-demo"
                                accept=".jpg,.jpeg,.png,.JPG,.JPEG" :action="actionUrl" :on-change="handleChange1"
                                :before-upload="beforeUpload">
                                <el-button size="medium">点击选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                        <el-col :span="3" :offset="21">
                            <el-button style="margin-top:10px;width: 100%" type="primary"
                                @click="questionBtn1()">确定</el-button>
                        </el-col>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import zTreeZN from "@//components/zTreeZN.vue";
import ckediter4 from "@/components/ck.vue";
import {
    GetywproTreeList,
    GetYWProUserAuth,
    AddYwFeedback,
    GetYwFeedbackList,
    YWFbAskedAndReply,
    DelYwFeedback,
} from "@/setAxios.js";
export default {
    name: "popularType",
    components: { zTreeZN, ckediter4 },
    data() {
        return {
            uid: Number(localStorage.getItem("id")),
            id: null,
            zNodes: null,
            loading: false,
            searchword: "",
            Addtitle: "",
            AddData: null,
            titleNum: "1",
            ADDFileShow: false,
            dataList: [],
            dataList1: [],
            addfbForm: {
                title: '',
                strcount: '',
                fileList: []
            },
            fbRule: {
                title: [{ required: true, message: "请输入", trigger: "blur" }],
                strcount: [{ required: true, message: "请输入", trigger: "blur" }],
                fileList: [
                    {
                        validator: (rule, value, callback) => {
                            const valid = value.length > 0
                            if (valid) {
                                return callback()
                            } else {
                                return callback(new Error(rule.message))
                            }
                        }, required: true, message: '请上传文件',
                    }
                ],
            },
            actionUrl: this.$store.state.baseUrl,
            // 人员权限
            upOrdelUser: [],
            downUser: [],
            replyUser: [],
            // 反馈
            feedbackShow: false,
            feedbackForm: {},
            feedbackRule: {
                fileName: [{ required: true, message: "请输入", trigger: "blur" }],
                title: [{ required: true, message: "请输入", trigger: "blur" }],
                strcount: [{ required: true, message: "请输入", trigger: "blur" }],
            },
            ShowQuestion: false,
            SGForm: {},
            fileList: [],
            SGRule: {
                strstatus: [
                    { required: true, message: "请输入问题状态", trigger: "blur" },
                ],
                title: [
                    { required: true, message: "请输入问题标签：", trigger: "blur" },
                ],
                username: [
                    { required: true, message: "请输入发起人", trigger: "blur" },
                ],
                creatdate: [
                    { required: true, message: "请输入发起时间", trigger: "blur" },
                ],
            },
            questionForm: {
                ywprojectfile: {},
            },
            questionDisable: false,
            replayStatus: false, //回复状态
            submitStatus: false, //确认状态
            zwStatus: true, //追问状态
            newFeedback: {},
            questionValue: "-1",
            questionOptions: [
                {
                    value: "-1",
                    label: "全部",
                },
                {
                    value: "0",
                    label: "待回复",
                },
                {
                    value: "1",
                    label: "已回复待确认",
                },
                {
                    value: "2",
                    label: "已关闭",
                },
                {
                    value: "3",
                    label: "已超时",
                },
            ],
            idTree: null,
        };
    },
    computed: {
        upOrdelUserAuthority() {
            return this.upOrdelUser.includes(Number(localStorage.getItem("id")));
        },
        downUserAuthority() {
            return this.downUser.includes(Number(localStorage.getItem("id")))
        },
        replyUserAuthority() {
            return this.replyUser.includes(Number(localStorage.getItem("id")))
        },
    },
    created() {
        this.GetywproTree();
        this.GetYWProUserAuthUser(7);
        this.getDataList();
    },
    methods: {
        questionValueChange(value) {
            this.questionValue = value;
            this.getDataList();
        },
        handleClose(done) {
            this.feedbackShow = false;
            this.ADDFileShow = false;
            this.ShowQuestion = false;
            this.questionDisable = !this.questionDisable;
            this.submitStatus = false;
            this.replayStatus = true;
            this.zwStatus = true;
            this.SGForm = {};
            this.$refs.upload.clearFiles();
            done();
        },
        // 文件树
        GetywproTree() {
            this.loading = true;
            GetywproTreeList({
                params: { xid: this.$store.state.xid, type: 4 },
            }).then((res) => {
                this.zNodes = res.Data;
                this.loading = false;
            });
        },
        getKeyworld(keyworld) {
            this.getDataList()
        },
        // 获取列表
        async getDataList(ids) {
            this.loading = true;
            let params = {
                searchword: this.searchword,
                projectid: this.$store.state.xid,
                type: 3,
                status: this.questionValue,
                pageindex: 1,
                pagesize: 9999,
                treeid: ids ? ids : 0,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            let res = await GetYwFeedbackList(fd);
            this.dataList = res.Data.length > 0 ? res.Data : [];
            this.dataList1 =
                res.Data.length > 0 ? res.Data.filter((el) => el.status != 0) : [];
            this.loading = false;
        },
        // 获取项目过程模块人员权限
        GetYWProUserAuthUser(type) {
            let params = {
                xid: this.$store.state.xid,
                type: type,
            };
            GetYWProUserAuth({ params }).then((res) => {
                if (res.Data) {
                    this.upOrdelUser =
                        res.Data.insertuids != null
                            ? res.Data.insertuids.split(",").map(Number)
                            : [];
                    this.replyUser =
                        res.Data.replyuids != null
                            ? res.Data.replyuids.split(",").map(Number)
                            : [];
                }
            });
        },
        // 做反馈操作
        lookQuestion(data) {
            this.ShowQuestion = true;
            this.SGForm = data;
            //状态回复设置
            if (data.status === 0) {
                //
                this.replayStatus = false;
                this.questionDisable = false;
                this.submitStatus = false;
            } else if (data.status === 1) {
                //回复待确认
                this.replayStatus = true;
                this.questionDisable = true;
                this.submitStatus = true;
                this.zwStatus = true;
            } else if (data.status === 2) {
                //已关闭
                this.submitStatus = true;
                this.questionDisable = true;
                this.replayStatus = false;
            }
        },
        // 不合格
        continueBtn(data) {
            this.newFeedback = {
                id: 0,
                feedbackid: this.SGForm.id,
                fbcontent: "",
            };
            this.zwStatus = false;
        },
        // 追问回复
        questionBtn1() {
            if (this.newFeedback.fbcontent == "") {
                this.$message.error('请填写完成数据!');
                return false
            }
            if (this.fileList.length == 0) {
                this.$message.error('请上传文件!');
                return false
            }
            let params = {
                fbid: this.newFeedback.feedbackid,
                projectid: this.$store.state.xid,
                type: 3,
                isclose: false,
                disposeid: 0,
                strcontent: this.newFeedback.fbcontent,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            this.fileList.forEach((file) => {
                fd.append("filses", file.raw);
            });
            YWFbAskedAndReply(fd).then((res) => {
                if (res.Code != 0) {
                    this.$message.success("操作成功");
                    this.ShowQuestion = false;
                    this.zwStatus = true;
                    this.addfbForm = {
                        title: '',
                        strcount: '',
                        fileList: []
                    };
                    this.fileList = [];
                    this.$refs.upload.clearFiles();
                    // this.submitStatus = false;
                    this.getDataList();
                } else {
                    this.$message.error("操作失败");
                }
            });
        },
        // 删除
        delChange(id) {
            this.$confirm("此操作将移除所选文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let params = {
                    ids: id,
                };
                DelYwFeedback(params).then((res) => {
                    if (res.Code > 0) {
                        this.$message({
                            type: "success",
                            message: "移除成功!",
                        });
                    }
                    this.getDataList();
                });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消操作",
                });
                this.loading = false;
            });
        },
        addFileZtree(id, data) {
            if (this.replyUser.length == 0) {
                this.$message.warning("请联系管理员设置指定处理人！")
                return false;
            }
            this.AddData = data;
            this.ADDFileShow = true;
            this.idTree = data.id;
        },
        // 添加文件
        submitUpdata(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let fd = new FormData();
                    this.addfbForm.fileList.forEach((file) => {
                        fd.append("filses", file.raw);
                    });
                    fd.append("projectid", this.$store.state.xid);
                    fd.append("type", 3);
                    fd.append("fileId", 0);
                    fd.append("treeid", this.idTree);
                    fd.append("title", this.addfbForm.title);
                    fd.append("strcount", this.addfbForm.strcount);
                    AddYwFeedback(fd).then((res) => {
                        if (res.Code != 0) {
                            this.$message.success("上传成功");
                            this.addfbForm = {
                                title: '',
                                strcount: '',
                                fileList: []
                            };
                            this.ADDFileShow = false;
                            this.$refs.upload.clearFiles();
                            this.getDataList();
                        } else {
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    this.$message.error("验证失败！");
                    return false;
                }
            });
        },
        handleChange(file, fileList) {
            this.$nextTick(() => {//等待照片上传完成，
                this.$refs.imageFile.clearValidate('fileList')
            })
            this.addfbForm.fileList = fileList;
        },
        handleChange1(file, fileList) {
            this.fileList = fileList;
        },
        beforeUpload(file) {
            var index = file.name.lastIndexOf(".");
            var suffix = file.name.substring(index + 1);
            var suffixs = ["jpg", "jpeg", "png", "JPG", "JPEG"];
            if (suffixs.indexOf(suffix) == -1) {
                this.$message({
                    message: "上传文件只能是 jpg、jpeg、png格式!",
                    type: "warning",
                });
                return false;
            }
            return true;
        },
        // 反馈
        feedbackChange(data) {
            this.feedbackShow = true;
            this.feedbackForm = {
                fileId: data.id,
                fileName: data.fname,
                title: "",
                strcount: "",
            };
        },
        submitfeedback(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid && this.feedbackForm.strcount.length > 0) {
                    let fd = new FormData();
                    this.feedbackForm.strcount = this.$refs.ck.ckeditor.getData();
                    fd.append("projectid", this.$store.state.xid);
                    fd.append("type", 3);
                    fd.append("fileId", this.feedbackForm.fileId);
                    fd.append("title", this.feedbackForm.title);
                    fd.append("strcount", this.feedbackForm.strcount);
                    AddYwFeedback(fd).then((res) => {
                        if (res.Code != 0) {
                            this.$message.success("上传成功");
                            this.feedbackForm = {};
                            this.feedbackShow = false;
                            this.$refs.upload.clearFiles();
                            this.getDataList();
                        } else {
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    this.$message.error("验证失败！");
                    return false;
                }
            });
        },
        // 做反馈操作
        questionChange(data) {
            this.questionForm = data;
            //回复人员
            if (
                this.replyUser.includes(Number(localStorage.getItem("id"))) === true ||
                this.questionForm.creatuser === Number(localStorage.getItem("id"))
            ) {
                // 权限
                if (this.questionForm.status === 0) {
                    this.replayStatus = false;
                    this.questionDisable = false;
                } else if (this.questionForm.status === 1) {
                    this.replayStatus = true;
                    this.questionDisable = true;
                    this.submitStatus = true;
                } else if (data.status === 2) {//已关闭
                    this.submitStatus = true;
                    this.questionDisable = true;
                    this.replayStatus = false
                }
            } else {
                this.questionDisable = true;
                this.replayStatus = false;
            }
            this.ShowQuestion = true;
        },
        // 确认回复
        questionBtn(data, status, index) {
            let result = false;
            this.SGForm.disposelsit.forEach((el) => {
                // 处理情况
                if (el.disposecontent != null) {
                    // 上传地址
                    if (el.disposefiles != null || this.fileList.length > 0) {
                        result = true
                    } else {
                        this.$message.error('请上传文件!');
                        result = false
                    }
                    // 都不为空
                    return result
                } else {
                    // 有空数据
                    this.$message.error('请填写完成数据!')
                    result = false
                }
                return result
            })
            // result, true为不空,false为空
            if (result) {
                let params = {
                    fbid: this.SGForm.id,
                    projectid: this.$store.state.xid,
                    type: 3,
                    isclose: status,
                    disposeid: data.id,
                    strcontent: !status ? data.disposecontent : ''
                }
                let fd = new FormData();
                for (var key in params) {
                    fd.append(key, params[key]);
                }
                this.fileList.forEach((file) => {
                    fd.append('filses', file.raw);
                })
                YWFbAskedAndReply(fd).then((res) => {
                    if (res.Code != 0) {
                        this.getDataList();
                        this.$message.success("操作成功");
                        this.ShowQuestion = false;
                        this.replayStatus = true;
                        this.questionDisable = true;
                        this.fileList = []
                        this.$refs.upload.clearFiles();
                    } else {
                        this.$message.error(res.Message);
                    }
                })
            }
        },
    },
};
</script>
<style lang="less" scoped>
.popularType-main {
    width: 100%;
    height: calc(100% - 10px);
    padding-top: 10px;

    .popularType_content {
        width: 100%;
        height: 100%;

        .content_left {
            width: 25%;
            height: 100%;
        }

        .content_center {
            width: 75%;
            height: 100%;
        }
    }

    .wirte {
        color: #fff;
    }

    .flex {
        width: 100%;
    }

    .menuStyle {
        background-image: url("../../../assets/img/Wisdom/Group\ 1901.png");
        background-repeat: no-repeat;
        background-position: center center;
        cursor: pointer;
        padding: 0px 40px;
        box-sizing: content-box;
        width: 14%;
        height: 100%;
        color: #fff;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .isActive {
        background-image: url("../../../assets/img/Wisdom/Group\ 3_1.png");
    }

    .content_style {
        width: 100%;
        height: 33%;

        .style_title {
            background-image: url("../../../assets/img/A三期/大屏/middle.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            font-size: 14px;
            padding: 10px 60px;
            font-weight: bold;
            color: #fff;
            // background-image: url("../../../assets/img/Wisdom/Group 3.png");
            // background-repeat: no-repeat;
            // background-size: 100% 100%;
            // font-size: 14px;
            // padding: 10px 25px;
            // font-weight: bold;
            // color: #fff;
        }

        .style_content {
            height: calc(100% - 74px);
            margin-top: 10px;
            background-color: rgba(0, 133, 247, 0.1);
            width: calc(100% -20px);
            padding: 10px;
            color: #fff;

            .bj_1 {
                background-image: url("../../../assets/img/Wisdom/椭圆\ 1\ 拷贝\ 31\ 灰大素材\ 拷贝\ 1.png");
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                text-align: center;
                font-weight: bold;
                width: 40%;
                height: 30%;
            }

            .bj_2 {
                background-image: url("../../../assets/img/Wisdom/1\ 86006.png");
                background-repeat: no-repeat;
                background-size: contain;
                background-position: 10% center;
                text-align: center;
                font-weight: bold;
                padding: 8px;
                letter-spacing: 5px;
                font-size: 20px;
                text-align: center;
                color: #04e8f8;
                font-family: "fzfs" !important;
            }

            .tian {
                position: relative;

                &::after {
                    position: absolute;
                    content: "天";
                    right: -30%;
                    color: #fff;
                    bottom: 2px;
                }
            }
        }
    }


    // 走马灯--图标改变
    .swiper {
        width: 80%;
        height: 100%;
    }

    .el-carousel__container {
        height: 100%;
    }

    .left-img1 {
        margin-right: 5px;
        cursor: pointer;
    }

    .right-img1 {
        margin-left: 5px;
        cursor: pointer;
    }

    .el-carousel__arrow--left,
    .el-carousel__arrow--right {
        display: none;
    }

    .el-carousel__item {
        width: 100%;

        .carousek {
            width: 100%;

            .carousel_Title {
                width: 100%;
                height: 40px;
                margin-top: 10px;
                font-size: 15px;
                justify-content: flex-start;
                padding-left: 10px;
                background-image: url("../../../assets/img/Intelligence/Group\ 2091.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                /* 设置背景图片的位置以及重复方式 */
                background-position: center top;
            }

            .carousel_content {
                height: 55%;
                margin-top: 10px;

                .content_mian {
                    width: 80%;
                    height: 70%;
                    margin-left: 10px;
                    font-size: 12px;
                }
            }
        }
    }

    /deep/.inputStyle .el-input.is-disabled .el-input__inner {
        color: #ccc !important;
    }

    /deep/.inputStyle .el-input .el-input__inner {
        color: #333 !important;
        /* 修改为你想要的颜色 */
    }

    /deep/.inputStyle .el-textarea__inner {
        color: #333 !important;
        border: 1px solid #ccc;
    }

    .font_col2 {
        margin-left: 10px;
        color: #4edce1;
    }

    .txt-cen-pa20-0 {
        text-align: right;
        padding: 20px 0;
    }
}
</style>
